import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Card, CardBody, Badge } from "reactstrap";

const WorkoutInfoSidebar = ({ isOpen, toggle }) => {
    return (
        <Offcanvas isOpen={isOpen} toggle={toggle} direction="end" style={{ width: "450px" }}>
            <OffcanvasHeader toggle={toggle} className="border-bottom pb-3">
                <div className="d-flex align-items-center gap-2">
                    <i className="mdi mdi-information-outline fs-4 text-primary"></i>
                    <div>
                        <h5 className="mb-0">Zonas de Treinamento</h5>
                        <small className="text-muted">Guia de intensidades e dicas gerais</small>
                    </div>
                </div>
            </OffcanvasHeader>
            <OffcanvasBody className="p-4 bg-light-subtle">
                <div className="mb-4">
                    <h6 className="fw-bold text-dark mb-3"><i className="mdi mdi-heart-pulse text-danger me-2"></i>O que são as zonas de intensidade?</h6>
                    <p className="text-muted small">
                        A natação utiliza divisões de zonas baseadas na Frequência Cardíaca ou Percepção Subjetiva de Esforço (PSE) para determinar o objetivo metabólico de cada série.
                    </p>
                    
                    <div className="d-flex flex-column gap-2 mb-4">
                        <Card className="border-0 shadow-sm mb-0">
                            <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-bold mb-0 text-success">A1 (Aeróbico 1)</h6>
                                    <Badge color="success" className="px-2">60-70% FC Máx</Badge>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                    Ritmo de base, aquecimento, soltura e recuperação ativa. Respiração fácil e relaxada.
                                </p>
                            </CardBody>
                        </Card>
                        <Card className="border-0 shadow-sm mb-0">
                            <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-bold mb-0 text-info">A2 (Aeróbico 2)</h6>
                                    <Badge color="info" className="px-2">70-80% FC Máx</Badge>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                    Ritmo moderado, constrói resistência cardiovascular de base. Respiração controlada, mas esforço notável.
                                </p>
                            </CardBody>
                        </Card>
                        <Card className="border-0 shadow-sm mb-0">
                            <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-bold mb-0 text-warning">A3 (Limiar Anaeróbico)</h6>
                                    <Badge color="warning" className="px-2">80-90% FC Máx</Badge>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                    Ponto de equilíbrio onde a produção e remoção de lactato se igualam (Threshold). Maior ganho de ritmo de prova.
                                </p>
                            </CardBody>
                        </Card>
                        <Card className="border-0 shadow-sm mb-0">
                            <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-bold mb-0 text-danger">VO2 Máximo</h6>
                                    <Badge color="danger" className="px-2">90-95% FC Máx</Badge>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                    Esforço para aumentar a capacidade de processamento de oxigênio. Séries curtas com mais descanso.
                                </p>
                            </CardBody>
                        </Card>
                        <Card className="border-0 shadow-sm mb-0">
                            <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <h6 className="fw-bold mb-0 text-dark">AN / Máximo</h6>
                                    <Badge color="dark" className="px-2">95-100% FC Máx</Badge>
                                </div>
                                <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                                    Treino anaeróbico lático/alático. Tiros muito curtos de velocidade explosiva máxima.
                                </p>
                            </CardBody>
                        </Card>
                    </div>

                    <h6 className="fw-bold text-dark mb-3"><i className="mdi mdi-chart-line text-primary me-2"></i>Como obter seus dados (Limiares)?</h6>
                    <Card className="border-0 border-start border-3 border-primary shadow-sm mb-4">
                        <CardBody className="p-3">
                            <ul className="text-muted small mb-0 ps-3">
                                <li className="mb-1"><strong>Teste de 30 Minutos (T-30):</strong> Nadar a maior distância possível em 30min; calcula o ritmo A3 (limiar).</li>
                                <li className="mb-1"><strong>Séries Progressivas:</strong> Testes de 7x200m aumentando ritmo até o máximo para achar as zonas pelo tempo.</li>
                                <li><strong>Smartwatches:</strong> Garmins e Apple Watches ajudam a estimar pela faixa de Frequência Cardíaca na água.</li>
                            </ul>
                        </CardBody>
                    </Card>

                    <h6 className="fw-bold text-dark mb-3"><i className="mdi mdi-lightbulb-on-outline text-warning me-2"></i>Dicas Rápidas para os Usuários</h6>
                    <div className="bg-white rounded-3 p-3 shadow-sm border lh-sm">
                        <ul className="text-muted mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                            <li className="mb-2">A maior parte do volume semanal (70-80%) deve ser nadado nas zonas A1 e A2.</li>
                            <li className="mb-2">Intervalos curtos (10" a 15") aumentam o esforço aeróbico. Se sentir que o ritmo caiu muito, o intervalo pode estar muito curto.</li>
                            <li>Tente mesclar tiros fortes (A3/VO2) com solturas frequentes (A1) para acostumar o corpo a remover ácido lático.</li>
                        </ul>
                    </div>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default WorkoutInfoSidebar;
